import { i18nPath } from 'config/i18nNs';
import PolicyTab from 'layout/PolicyTab';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { getSelectOptions } from 'utils/format';
import { projectId } from 'utils/urlQueries';
import { getPathInfo } from 'utils/versionUtils';

export interface PrivacyProps {
  id: string;
}

const PrivacyDetails: React.FC<PrivacyProps> = ({ id }) => {
  const { t } = useTranslation();
  const { activity: currActivity } = useParams<{ activity?: string }>();
  const history = useHistory();
  const { locPath } = getPathInfo();

  const activities: Array<{
    title: string;
    label: string;
    tabId: string;
    sections: Array<{
      title: string;
      content: string;
      anchor: string;
    }>;
  }> = t(`${i18nPath.globalVariant}.activities`);

  const activitiesLocal: Array<{
    title: string;
    label: string;
    tabId: string;
    sections: Array<{
      title: string;
      content: string;
      anchor: string;
    }>;
  }> = t(`${i18nPath.local}.activities`);

  const tabData =
    activities &&
    activities.find((activity) => activity.tabId === currActivity);
  const activityIndex =
    activities &&
    Array.isArray(activities) &&
    activities.findIndex((element) => element.tabId === currActivity);
  const localIndex =
    activitiesLocal &&
    Array.isArray(activitiesLocal) &&
    activitiesLocal.findIndex((element) => element.tabId === currActivity);
  const tabLocalData =
    activitiesLocal &&
    Array.isArray(activitiesLocal) &&
    activitiesLocal.find((activity) => activity.tabId === currActivity);
  const selectOptions = getSelectOptions(activities);

  // Handle navigation when option is selected
  const handleTabChange = (tabId: string) => {
    history.push(`/${locPath}/privacy/${tabId}?id=${projectId}`);
  };

  // If activity doesn't exist do nothing
  if (!tabData) {
    return null;
  }

  return (
    <PolicyTab
      id={id}
      i18nPrefix={`${i18nPath.globalVariant}.activities.${activityIndex}`}
      locali18nPrefix={`${i18nPath.local}.activities.${localIndex}`}
      content={tabData}
      selectOptions={selectOptions}
      localContent={tabLocalData}
      onTabChange={handleTabChange}
    />
  );
};

export default PrivacyDetails;
